import { IkeToken } from '@ikegps/core-api';
import { T, Translate } from '../../i18n';
import { m, type MithrilVNode } from '../../mithril';
import { Services } from '../../services';
import { addStyles } from '../theme';
import { PanelResizeController, type PanelResizeOptions } from './resize.controller';
import { CSS, Style } from './resizable.style';

addStyles(Style);

/** A page opts a panel in by swapping its fixed size for `var(<cssVar>, <original size>)`. */
export class ResizeHandle {
	private readonly controller: PanelResizeController;
	private readonly isVertical: boolean;

	constructor(options: PanelResizeOptions) {
		this.controller = new PanelResizeController(options);
		this.isVertical = options.axis === 'y';
	}

	view(): MithrilVNode {
		if (!Services.Token.has(IkeToken.FEATURE_COMPONENT_USABILITY)) {
			// A department switch keeps the live page instance, and the disabled path renders no element, so
			// this is the only hook left that can hand the panel back to its stylesheet default.
			this.controller.reset();
			return null;
		}

		this.controller.ensureRestored();

		return m('div', {
			className: `${CSS.handle} ${this.isVertical ? CSS.handleY : CSS.handleX}`,
			role: 'separator',
			// A separator's orientation is the line it draws, not the direction it is dragged.
			'aria-orientation': this.isVertical ? 'horizontal' : 'vertical',
			'aria-label': Translate(T.RESIZE_PANEL),
			title: Translate(T.RESIZE_PANEL),
			tabindex: 0,
			onmousedown: (event: MouseEvent) => this.controller.onMouseDown(event),
			onkeydown: (event: KeyboardEvent) => this.controller.onKeyDown(event),
			onremove: () => this.controller.dispose(),
		});
	}
}
